import React, { useState, useEffect, useRef } from "react";
import { Grid, Box, Button } from "@material-ui/core";
import "react-datasheet-grid/dist/style.css";
import POAlertDialog from "./PoTableAlert";
import {
  getCostCenterDataForExcel,
  getg_laccountForExcel,
} from "../../actions";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import axios from "axios";

import "./style.css";
import { addZeroes } from "../../../../Functions";

import "handsontable/dist/handsontable.full.min.css";
import { HotTable } from "@handsontable/react";
import { registerAllModules } from "handsontable/registry";
import CustomSnackbar from "../../../../CustomSnackbar";

registerAllModules();

const GL_Table_APS = ({
  formState,
  setFormState,
  disabled,
  setGLAccountTotal,
  importPaymentDetail,
  setImportPaymentDetail,
  setErrorMessageForAmount,
}) => {
  const tableData = {
    rowId: 0,
    accountId: 0,
    invoice_Id: parseInt(formState?.invoice_Id),
    glAccount: "",
    costCenter: "",
    accountType: "",
    amount: 0,
    costCenterOwner: "",
    stCode: formState?.salesTaxCode?.split("-")[0].trim() || "",
    order: "",
    profitCenter: "",
    wbsElement: "",
    created_By: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    fixedAsset: "",
    tType: "",
    description: `${formState.invoice_Desc}`,
    expenseDate: "",
    horizonId: "",
    department: "",
    vendorCode: "",
  };

  const invoice_Payment_Details = {
    rowId: 0,
    inv_Payment_Id: 0,
    invoice_Id: parseInt(formState?.invoice_Id),
    postingKey: "",
    sglInd: "",
    tType: "",
    paymentTerms: "",
    paymentDays: "",
    paymentMethod: "",
    paymentMethSupp: "",
    individualPayee: true,
    account: "",
    amount: 0,
    taxAmount: 0,
    dueOn: new Date(),
    taxCode: formState?.salesTaxCode,
    description: "",
    order: "",
    costCenter: "",
    wbsElement: "",
    profitCenter: "",
    createdBy: "",
    createdDate: new Date(),
  };

  const [costCenterList, setCostCenterList] = useState([]);
  const [costCenterLoading, setCostCenterLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [glAccount, setGlAccount] = useState([]);
  const [loading, setLoading] = useState([]);
  const [costLoading, setCostLoading] = useState([]);
  const [glAccountLoading, setGlAccountLoading] = useState(false);

  const hotRef = useRef(null);
  const [columns, setColumns] = useState([]);

  const columnHeaders = [
    "",    // ← Auto number column
    "D/C",
    "GL Account",
    "Text",
    "Amount",
    "CostCenter",
    // "CC Owner Code",
    "CC Owner",
    // "Order",
    // "ST Code",
    "Profit Center",
    "WBS element", 
  ];

  useEffect(() => {
    if (formState?.invoice_Accounts?.length > 0 && !formState?.isPCDV) {
      let data = [...formState?.invoice_Accounts];
      let tempArr = importPaymentDetail?.invoice_Payment_Details
        ? [...importPaymentDetail?.invoice_Payment_Details]
        : [];
      formState?.invoice_Accounts?.map((item, index) => {
        data[index].stCode =
          formState?.salesTaxCode?.split("-")[0].trim() || "";
        data[index].taxCode =
          formState?.salesTaxCode?.split("-")[0].trim() || "";
        data[index].taxAmount = Number(formState?.salesTaxAmount);
      });
      importPaymentDetail?.invoice_Payment_Details?.map((item, index) => {
        tempArr[index].stCode =
          formState?.salesTaxCode?.split("-")[0].trim() || "";
        tempArr[index].taxCode =
          formState?.salesTaxCode?.split("-")[0].trim() || "";
        if (item.postingKey !== "31") {
          tempArr[index].taxAmount = Number(formState?.salesTaxAmount);
        }
        // tempArr[index].accountType = item.accountType ? item.accountType : item.AccountType ? item.AccountType : "Debit"
      });
      setFormState((formState) => ({ ...formState, invoice_Accounts: data }));
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: tempArr,
      }));
    }
  }, [formState.salesTaxCode, formState.salesTaxAmount]);

  useEffect(() => {
    const data = [
      {
    data: "rowId", // no data field needed
    readOnly: true,
    width: 40,
    renderer: function (instance, td, row, col, prop, value, cellProperties) {
      td.innerHTML = row + 1; // Auto-increment row number
      td.style.textAlign = "center";
      return td;
    },
  },
      {
        data: "accountType",
        type: "dropdown",
        source: ["Debit", "Credit"],
        strict: true,
        width: 80,
      },
      {
        data: "glAccount",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetChargeAccount_v1/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.GLAccount + " - " + m.ShortText;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 230,
      },
      {
        data: "description",
        // width: 260,
        type: "text",
      },
      {
        data: "amount",
        width: 80,
        type: "numeric",
        numericFormat: {
          pattern: "0,0.00",
          culture: "en-US", // this is the default culture, set up for USD
        },
      },
      {
        data: "costCenter",
        type: "autocomplete",
        source: function (query, proces) {
          var data = { query: query };
          let _ca = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _ca = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetCostCenters_v1/${_ca ? _ca : "-1"}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.CostCenterCode + " - " + m.Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 200,
      },
      // {
      //   data: "costCenterOwner",
      //   width: 1,
      //   type: "text",
      // },
      {
        data: "CostCenterOwnerName",
        width: 240,
        type: "text",
      },
      // {
      //   data: "order",
      //   width: 100,
      //   type: "text",
      // },
      
      // {
      //   data: "stCode",
      //   width: 80,
      //   type: "text",
      // },
      {
        data: "profitCenter",
        width: 110,
        type: "text",
      },
      {
        data: "wbsElement",
        width: 100,
        type: "text",
      },
    ];

    setColumns(data);
  }, [formState?.invoice_Accounts]);

  const handleAfterChange = async (changes, source) => {
    if (changes == null || changes == undefined) return;
    var self = this;
    const str = JSON.stringify(formState?.invoice_Accounts);
    const tempArr = JSON.parse(str);
    let tempinvoice_Payment_Details =
      importPaymentDetail.invoice_Payment_Details;

    // changes.forEach(async function (r, i) {
    for (let i = 0; i < changes.length; i++) {
      tempArr[changes[i][0]]["accountId"] = 0;
      tempArr[changes[i][0]]["invoice_Id"] = parseInt(formState?.invoice_Id);

      tempArr[changes[i][0]]["created_By"] = "";
      tempArr[changes[i][0]]["created_On"] = new Date();
      tempArr[changes[i][0]]["updated_By"] = "";
      tempArr[changes[i][0]]["updated_On"] = new Date();

      if (
        !tempArr[changes[i][0]]?.rowId ||
        !tempinvoice_Payment_Details.find(
          (x) => x.rowId === tempArr[changes[i][0]]?.rowId
        )
      ) {
        const num = Math.random();
        tempArr[changes[i][0]].rowId = num;

        const invoice_Payment_Details_str = JSON.stringify(
          invoice_Payment_Details
        );
        const invoice_Payment_Details_parse = JSON.parse(
          invoice_Payment_Details_str
        );

        invoice_Payment_Details_parse.rowId = num;
        tempinvoice_Payment_Details = [
          ...tempinvoice_Payment_Details,
          invoice_Payment_Details_parse,
        ];
      }
      if (changes[i][1] == "costCenter") {
        var _cc = changes[i][3];
        // var data = { 'costCenterCode': _cc.split('-')[0].trim() };
        if (
          tempArr[changes[i][0]]["profitCenter"] ||
          tempArr[changes[i][0]]["wbsElement"]
        ) {
          setAlertMessage(
            "Profit center is already entered, so can't select cost center"
          );
          tempArr[changes[i][0]]["costCenterOwner"] = "";
          tempArr[changes[i][0]]["costCenterOwnerName"] = "";
          tempArr[changes[i][0]]["costCenter"] = "";
        } else {
          if (
            Array.isArray(tempinvoice_Payment_Details) &&
            !formState?.pO_Based
          ) {
            tempinvoice_Payment_Details.find(
              (x) => x.rowId === tempArr[changes[i][0]]?.rowId
            ).costCenter = changes[i][3];
          }
          await axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetEmployeeByCostCenter_v1/${_cc
              .split("-")[0]
              .trim()}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data != undefined) {
                tempArr[changes[i][0]]["costCenterOwner"] =
                  response.data.employeeCode;
                tempArr[changes[i][0]]["costCenterOwnerName"] =
                  response.data.employeeName;

                // if (
                //   Array.isArray(tempinvoice_Payment_Details) &&
                //   !formState?.pO_Based
                // ) {
                //   tempinvoice_Payment_Details.find(
                //     (x) => x.rowId === tempArr[changes[i][0]]?.rowId
                //   ).costCenter = changes[i][3];
                // }

                if (i === changes.length - 1) {
                  setFormState((formState) => ({
                    ...formState,
                    invoice_Accounts: tempArr,
                  }));
                  if (!formState?.pO_Based) {
                    const tempStringify = JSON.stringify(
                      tempinvoice_Payment_Details
                    );
                    const tempParse = JSON.parse(tempStringify);
                    setImportPaymentDetail((importPaymentDetail) => ({
                      ...importPaymentDetail,
                      invoice_Payment_Details: tempParse,
                    }));
                  }
                }
              }
            })
            .catch(function (err) {
              console.log(err);
            });

          await axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetCostCenters_v1/${_cc.split("-")[0].trim()}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data.length > 0) {
                tempArr[changes[i][0]]["costCenter"] =
                  response.data[0].CostCenterCode +
                  " - " +
                  response.data[0].Name;

                if (i === changes.length - 1) {
                  setFormState((formState) => ({
                    ...formState,
                    invoice_Accounts_list: tempArr,
                  }));
                }
                if (
                  Array.isArray(tempinvoice_Payment_Details) &&
                  !formState?.pO_Based
                ) {
                  tempinvoice_Payment_Details.find(
                    (x) => x.rowId === tempArr[changes[i][0]]?.rowId
                  ).costCenter = response.data[0].CostCenterCode;
                }
              } else {
                tempArr[changes[i][0]]["costCenter"] = "";
                tempinvoice_Payment_Details.find(
                  (x) => x.rowId === tempArr[changes[i][0]]?.rowId
                ).costCenter = "";
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        }

        // self
        //   .getInstance()
        //   .setDataAtCell(changes[i][0], 10, formState?.invoice_Desc);
        // tempArr[changes[i][0]]["description"] = formState?.invoice_Desc;
      } else if (changes[i][1] == "glAccount") {
        var _ca = changes[i][3];
        if (_ca != null && _ca != "" && _ca.split("-").length > 0) {
          // var data = { query: _ca };
          if (
            Array.isArray(tempinvoice_Payment_Details) &&
            !formState?.pO_Based &&
            changes.length === 1
          ) {
            tempinvoice_Payment_Details.find(
              (x) => x.rowId === tempArr[changes[i][0]]?.rowId
            ).account = changes[i][3].split("-")[0].trim();
            tempinvoice_Payment_Details.find(
              (x) => x.rowId === tempArr[changes[i][0]]?.rowId
            ).accountName = changes[i][3].split("-")[1]?.trim() || "";
          }

          tempArr[changes[i][0]]["glAccount"] = changes[i][3];
          // if (changes.length > 1) {
          let _gl = "-1";
          if (_ca != null && _ca != "" && _ca.split("-").length > 0) {
            _gl = _ca.split("-")[0].trim();
          }
          await axios({
            method: "get", //you can set what request you want to be
            url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/${_gl}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data.length > 0)
                tempArr[changes[i][0]]["glAccount"] =
                  response.data[0].GLAccount +
                  " - " +
                  response.data[0].ShortText;
              else tempArr[changes[i][0]]["glAccount"] = "";

              if (
                Array.isArray(tempinvoice_Payment_Details) &&
                !formState?.pO_Based &&
                response.data.length > 0
              ) {
                tempinvoice_Payment_Details.find(
                  (x) => x.rowId === tempArr[changes[i][0]]?.rowId
                ).account = response.data[0].GLAccount;
                tempinvoice_Payment_Details.find(
                  (x) => x.rowId === tempArr[changes[i][0]]?.rowId
                ).accountName = response.data[0].ShortText;
              } else {
                tempinvoice_Payment_Details.find(
                  (x) => x.rowId === tempArr[changes[i][0]]?.rowId
                ).account = "";
                tempinvoice_Payment_Details.find(
                  (x) => x.rowId === tempArr[changes[i][0]]?.rowId
                ).accountName = "";
              }

              if (i === changes.length - 1) {
                setFormState((formState) => ({
                  ...formState,
                  invoice_Accounts: tempArr,
                }));
                if (!formState?.pO_Based) {
                  const tempStringify = JSON.stringify(
                    tempinvoice_Payment_Details
                  );
                  const tempParse = JSON.parse(tempStringify);
                  setImportPaymentDetail((importPaymentDetail) => ({
                    ...importPaymentDetail,
                    invoice_Payment_Details: tempParse,
                  }));
                }
              }
            })
            .catch(function (err) {
              console.log(err);
            });
          // }

          //return;
        }
        // var instance = self.getInstance();
        if (
          formState?.salesTaxCode?.split("-")[0].trim() != null &&
          formState?.salesTaxCode?.split("-")[0].trim() != ""
        ) {
          tempArr[changes[i][0]]["stCode"] = formState?.salesTaxCode
            .split("-")[0]
            .trim();
          // instance.setDataAtCell(
          //   changes[i][0],
          //   7,
          //   formState?.salesTaxCode.split("-")[0].trim()
          // );
        }

        // self
        //   .getInstance()
        //   .setDataAtCell(changes[i][0], 10, formState?.invoice_Desc);

        // tempArr[changes[i][0]]["description"] = formState?.invoice_Desc;
        if (
          Array.isArray(tempinvoice_Payment_Details) &&
          !formState?.pO_Based
        ) {
          if (
            !tempinvoice_Payment_Details.find(
              (x) => x.rowId === tempArr[changes[i][0]]?.rowId
            ).description
          ) {
            tempinvoice_Payment_Details.find(
              (x) => x.rowId === tempArr[changes[i][0]]?.rowId
            ).description = formState?.invoice_Desc;
          }
        }
      } else if (changes[i][1] == "accountType") {
        tempArr[changes[i][0]]["accountType"] = changes[i][3];
        if (
          Array.isArray(tempinvoice_Payment_Details) &&
          !formState?.pO_Based
        ) {
          tempinvoice_Payment_Details.find(
            (x) => x.rowId === tempArr[changes[i][0]]?.rowId
          ).postingKey = changes[i][3] === "Credit" ? "50" : "40";
        }
      } else if (changes[i][1] == "amount") {
        const amt = changes[i][3];
        let newAmt = 0;
        if (typeof amt === "string") {
          const amt1 = Number(amt.replace(/,/g, ""));
          newAmt = amt1 ? amt1.toFixed(2) : 0;
        } else {
          newAmt = amt ? amt.toFixed(2) : 0;
        }

        tempArr[changes[i][0]]["amount"] = newAmt;
        if (
          Array.isArray(tempinvoice_Payment_Details) &&
          !formState?.pO_Based
        ) {
          tempinvoice_Payment_Details.find(
            (x) => x.rowId === tempArr[changes[i][0]]?.rowId
          ).amount = newAmt;
        }
      } else if (changes[i][1] == "order") {
        tempArr[changes[i][0]]["order"] = changes[i][3];
        if (
          Array.isArray(tempinvoice_Payment_Details) &&
          !formState?.pO_Based
        ) {
          tempinvoice_Payment_Details.find(
            (x) => x.rowId === tempArr[changes[i][0]]?.rowId
          ).order = changes[i][3];
        }
      } else if (changes[i][1] == "stCode") {
        tempArr[changes[i][0]]["stCode"] = changes[i][3];
        if (
          Array.isArray(tempinvoice_Payment_Details) &&
          !formState?.pO_Based
        ) {
          tempinvoice_Payment_Details.find(
            (x) => x.rowId === tempArr[changes[i][0]]?.rowId
          ).stCode = changes[i][3];
        }
      } else if (changes[i][1] == "profitCenter") {
        if (!tempArr[changes[i][0]]["costCenter"]) {
          tempArr[changes[i][0]]["profitCenter"] = changes[i][3];
          if (
            Array.isArray(tempinvoice_Payment_Details) &&
            !formState?.pO_Based
          ) {
            tempinvoice_Payment_Details.find(
              (x) => x.rowId === tempArr[changes[i][0]]?.rowId
            ).profitCenter = changes[i][3];
          }
        } else {
          setAlertMessage(
            "Cost center is already selected, so can't enter profit center"
          );
          tempArr[changes[i][0]]["profitCenter"] = "";
        }
      } else if (changes[i][1] == "wbsElement") {
        if (!tempArr[changes[i][0]]["costCenter"]) {
          tempArr[changes[i][0]]["wbsElement"] = changes[i][3];
          if (
            Array.isArray(tempinvoice_Payment_Details) &&
            !formState?.pO_Based
          ) {
            tempinvoice_Payment_Details.find(
              (x) => x.rowId === tempArr[changes[i][0]]?.rowId
            ).wbsElement = changes[i][3];
          }
        } else {
          setAlertMessage(
            "Cost center is already selected, so can't enter WBS Element"
          );
          tempArr[changes[i][0]]["wbsElement"] = "";
        }
      } else if (changes[i][1] == "description") {
        tempArr[changes[i][0]]["description"] = changes[i][3];
        if (
          Array.isArray(tempinvoice_Payment_Details) &&
          !formState?.pO_Based
        ) {
          tempinvoice_Payment_Details.find(
            (x) => x.rowId === tempArr[changes[i][0]]?.rowId
          ).description = changes[i][3];
        }
      }
    }
    // });

    setFormState((formState) => ({
      ...formState,
      invoice_Accounts: tempArr,
    }));
    if (!formState?.pO_Based) {
      const tempStringify = JSON.stringify(tempinvoice_Payment_Details);
      const tempParse = JSON.parse(tempStringify);
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: tempParse,
      }));
    }
    getBalance();
    countHandler(tempArr);
  };
  useEffect(() => {
  const handleResize = () => {
    if (hotRef.current) {
      hotRef.current.hotInstance.render(); // ✅ re-render the table
      hotRef.current.hotInstance.updateSettings({ stretchH: "all" }); // ✅ re-stretch
    }
  };

  // Listen for window resize (sidebar collapse triggers resize)
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

  const deleteInput = (index, rowId) => {
    const filteredData = formState?.invoice_Accounts?.filter(
      (x, i) => i !== index
    );
    const finded = formState?.invoice_Accounts?.find((x, i) => i !== index);
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts: filteredData,
    }));

    const filteredPaymentDetail =
      importPaymentDetail?.invoice_Payment_Details?.filter(
        (x, i) => x?.rowId !== rowId
      );
    // if (formState?.isImport) {
    setImportPaymentDetail((importPaymentDetail) => ({
      ...importPaymentDetail,
      invoice_Payment_Details: filteredPaymentDetail,
    }));
    // }
    countHandler(filteredData);
  };

  const getBalance = () => {
    var hist = {};
    formState?.taxCard_List.map(function (a) {
      if (a.taxType in hist)
        hist[a.taxType] =
          convertToFloat(a.amount) + convertToFloat(hist[a.taxType]);
      else hist[a.taxType] = convertToFloat(a.amount);
    });
    // this.message = "";
    setErrorMessageForAmount("");

    for (const [key, value] of Object.entries(hist)) {
      if (key == "null") continue;
      if (
        formState?.pO_Based &&
        convertToFloat(value) != formState.invoice_Amount &&
        (key.indexOf("Y1") > -1 ||
          key.indexOf("Y3") > -1 ||
          key.indexOf("Z1") > -1 ||
          key.indexOf("Z3") > -1)
      ) {
        setErrorMessageForAmount(
          "Income Tax WH base amount must be equal to Invoice Amount."
        );

        // this.message = "Income Tax WH base amount must be equal to Invoice Amount.";
        //window.scrollTo(0,0);
        return;
      } else if (
        formState?.pO_Based &&
        convertToFloat(value) > formState.invoice_Amount &&
        (key.indexOf("Y2") > -1 ||
          key.indexOf("Y4") > -1 ||
          key.indexOf("Z2") > -1 ||
          key.indexOf("Z4") > -1)
      ) {
        // this.isSuccess = false;
        // this.isError = true;
        // this.message =
        setErrorMessageForAmount(
          "Sales Tax WH base amount is exceeding Invoice Amount."
        );
        //window.scrollTo(0,0);
        return;
      }
    }
  };

  const convertToFloat = (num) => {
    try {
      if (num == undefined || num == "") return parseFloat(0);
      else return parseFloat(num.toString().replaceAll(",", ""));
    } catch (err) {
      return parseFloat(0);
    }
  };
  useEffect(() => {
    getCostCenterDataForExcel(
      "",
      setCostCenterLoading,
      setCostCenterList,
      setCostLoading
    );
    getg_laccountForExcel("", setLoading, setGlAccount, setGlAccountLoading);
  }, []);

  const addInput = () => {
    const num = Math.random();
    invoice_Payment_Details.rowId = num;
    invoice_Payment_Details.taxCode = formState?.salesTaxCode;
    tableData.rowId = num;
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts: [...formState?.invoice_Accounts, tableData],
    }));
    if (
      (formState?.isImport && !formState?.pO_Based) ||
      (formState?.isVPPayment && !formState?.pO_Based) ||
      !formState?.pO_Based
    ) {
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: [
          ...importPaymentDetail?.invoice_Payment_Details,
          invoice_Payment_Details,
        ],
      }));
    }
  };

  const countHandler = (tempArray) => {
    let total = 0;
    for (let index = 0; index < tempArray.length; index++) {
      const item = tempArray[index];
      if (item.accountType === "Debit") {
        total = total + parseFloat(item.amount || 0);
      } else if (item.accountType === "Credit") {
        total = total - parseFloat(item.amount || 0);
      }
    }

    setGLAccountTotal(total);
  };

  const calculateTotalGLAmount = () => {
    const totalGLAmount = formState?.invoice_Accounts?.reduce(
      (accumulator, currentValue) => {
        const amountWithoutCommas = String(currentValue?.amount).replace(
          /,/g,
          ""
        );
        const numericAmount = Number(Number(amountWithoutCommas)?.toFixed(2));
  
        if (currentValue?.accountType === 'Debit') {
          return accumulator + numericAmount;  
        } else if (currentValue?.accountType === 'Credit') {
          return accumulator - numericAmount;  
        }
        return accumulator; 
      },
      0
    );
  
    return Math.abs(totalGLAmount);
  };
  const totalAmount = calculateTotalGLAmount();

  const handleBeforeRemoveRow = (a, b, c, d, e, f) => {
    let tempArr = formState?.invoice_Accounts;
    let tempinvoice_Payment_Details =
      importPaymentDetail.invoice_Payment_Details;
    for (let index = 0; index < c.length; index++) {
      const rowIndex = c[index];
      const rowId = formState?.invoice_Accounts[rowIndex].rowId;
      tempArr = tempArr.filter((x) => x.rowId !== rowId);
      tempinvoice_Payment_Details = tempinvoice_Payment_Details.filter(
        (x) => x.rowId !== rowId
      );
    }
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts: tempArr,
    }));

    setImportPaymentDetail((importPaymentDetail) => ({
      ...importPaymentDetail,
      invoice_Payment_Details: tempinvoice_Payment_Details,
    }));
  };

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
           width: "0",
        //  overflowX: "auto", 
         zIndex: "0" }}
      >
        <HotTable
          className="custom-hot-table"
          data={formState?.invoice_Accounts}
          colHeaders={columnHeaders}
          columns={columns}
          manualRowResize={true}
          manualColumnResize={true}
          rowHeaders={false}
          // height="200"
          stretchH="all"
          rowHeaderWidth={25}
          contextMenu={true}
          filters={true}
          width="100%"
          hiddenColumns={false}
          readOnly={disabled}
          dropdownMenu={true}
          ref={hotRef}
          beforeRemoveRow={handleBeforeRemoveRow}
          afterChange={handleAfterChange}
          licenseKey="non-commercial-and-evaluation" // for non-commercial use
        />

        <Grid container spacing={0} mt={1}>
          <Grid item sm={6} md={3} lg={1}>
            <b>Total GL Amount:</b>
          </Grid>
          <Grid item sm={6} md={3} lg={2} style={{ paddingLeft: "4px" }}>
            <b>
              {totalAmount?.toLocaleString()}
              {/* {addZeroes(
                formState?.invoice_Accounts
                  ?.map((data) => data.amount)
                  .reduce((prev, curr) => Number(prev) + Number(curr), 0)
              )} */}
            </b>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default GL_Table_APS;
